import React from 'react';
import { Image } from 'react-bootstrap';

const Logo = ({ small = false }) => {
  return <Image src={`${process.env.PUBLIC_URL}/logo.png`} height={small ? 30 : 50} />;
};

export default Logo;
